import { createAction, props } from '@ngrx/store';

export const setOfferReference = createAction(
  '[View Offers] Set Offer Reference',
  props<{ payload: string }>()
);

export const clearOfferReference = createAction(
  '[View Offers] Clear Offer Reference'
);

export type OfferReferenceActions =
  | typeof setOfferReference
  | typeof clearOfferReference;
